import awsExports from "../aws-exports";
import { getEnv } from "./appUtils";
import { clearCachedProduktlyToken } from "./produktlyUtils";

export const getCognitoDomain = (env) => {
  if (!env) {
    env = getEnv();
  }

  switch (env) {
    case "dev":
      return "https://dev-auth.transloads.co";
    case "hotfix":
      return "https://hotfix-auth.transloads.co";
    case "prod":
      return "https://auth.transloads.co";
    default:
      return "https://auth.transloads.co";
  }
};

export const getRedirectUris = (env) => {
  switch (env) {
    case "dev":
      return ["http://localhost:3000/", "https://test.transloads.co/"];
    case "hotfix":
      return ["http://localhost:3000/", "https://stage.transloads.co/"];
    case "prod":
      return [
        "http://localhost:3000/",
        "https://app.transloads.co/",
        "https://twa.transloads.co/",
      ];
    default:
      return [
        "http://localhost:3000/",
        "https://app.transloads.co/",
        "https://twa.transloads.co/",
      ];
  }
};

/**
 * Public origin for URLs handed to people off this machine (QR codes,
 * emailed links). localhost would be unreachable from a driver's phone,
 * so it maps to the environment's hosted domain; any deployed origin is
 * already public and passes through unchanged.
 */
export const getPublicOrigin = () => {
  const origin = window.location.origin;
  if (!/^https?:\/\/localhost(:\d+)?$/.test(origin)) return origin;
  const uris = getRedirectUris(getEnv());
  const hosted = uris.find((u) => !u.startsWith("http://localhost"));
  return hosted ? hosted.replace(/\/$/, "") : origin;
};

export const getOauthConfig = () => {
  const env = getEnv();

  return {
    domain: getCognitoDomain(env),
    scope: [
      "phone",
      "email",
      "openid",
      "profile",
      "aws.cognito.signin.user.admin",
    ],
    redirectSignIn: getRedirectUris(env),
    redirectSignOut: getRedirectUris(env),
    responseType: "code",
  };
};

/**
 * Core sign-out redirect: clears global app state and redirects to Cognito logout.
 *
 * For React-specific cleanup (e.g. clearing context state, OIDC removeUser),
 * callers should perform those steps before invoking this function.
 */
export const signOutRedirect = () => {
  const clientId = awsExports.aws_user_pools_web_client_id;
  const logoutUri = window.location.origin;
  const cognitoDomain = getCognitoDomain();

  // Clear global app state
  window.appUser = null;
  window.getAuthToken = () => null;
  clearCachedProduktlyToken();

  // Redirect to Cognito hosted logout
  window.location.href = `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(
    logoutUri,
  )}`;
};
